export default __webpack_public_path__ + "static/media/tap-logo.cbc86fc1.png";